const window = require('window');
const Backbone = require('backbone');
const FacetGroupsExpandStatuses = require('app/models/store/client/category/facetGroupsExpandStatuses');

module.exports = Backbone.View.extend({
	activeFacetClass: 'facet-active',
	events: {
		'click .js-facet-banner-link': '_handleContentFacetClick'
	},
	initialize(options = {}) {
		this.options = options;
		this.$bannerLinks = this.$('.js-facet-banner-link');
		if (this.$bannerLinks.length) {
			this.listenTo(this.collection, 'update', this._resetActiveBanners.bind(this));
		}
	},
	_handleContentFacetClick(e) {
		e.preventDefault();
		e.stopPropagation();
		const $banner = $(e.currentTarget),
			href = $banner.attr('href'),
			isActive = $banner.hasClass(this.activeFacetClass),
			intcmpValue = window.BCOM.util.getQueryStringParameter('intcmp', $banner.attr('href')),
			// _common_decorators.js builds this data object for groupItems
			facetData = $banner.data('facets') || [],
			trackingString = intcmpValue ? `intcmp=${intcmpValue}` : '';

		this._setFacetGroupsExpandStatuses(facetData, !isActive);
		this._parseAndSetFacetValues(facetData, !isActive, trackingString, () => href && window.location.assign(href));
	},
	_resetActiveBanners() {
		const selectedFacetQueries = this.collection.getFacetQueries();
		this.$bannerLinks.each((index, el) => {
			this._setActiveFacetBanner($(el), selectedFacetQueries);
		});
	},
	_setActiveFacetBanner($banner, selectedFacetQueries) {
		const facetDataArray = $banner.data('facets'),
			isActive = facetDataArray ? this._isActiveFacet(facetDataArray, selectedFacetQueries) : false;
		$banner.toggleClass(this.activeFacetClass, isActive);
	},
	_isActiveFacet(facetDataArray, selectedFacetQueries) {
		return Array.isArray(facetDataArray) && facetDataArray.length
			? facetDataArray.every((f) => selectedFacetQueries.indexOf(f.facetStr) !== -1)
			: false;
	},
	_getFacetRangeValuesFromQueryString(facet) {
		if (!facet || !facet.facetStr) {
			return;
		}
		const groupFacetQueries = facet.facetStr.split('&').filter((query) => {
				return query.indexOf(facet.facetId) !== -1;
			}),
			min = groupFacetQueries[0].split('=')[1],
			max = groupFacetQueries[1].split('=')[1];
		return { min, max };
	},
	_parseAndSetFacetValues(facetData, setSelected, trackingString, onError) {
		facetData.forEach((facet) => {
			if (facet.value === 'stats') {
				const values = this._getFacetRangeValuesFromQueryString(facet);
				if (values) {
					this._triggerFacetRangeChange(facet, setSelected, trackingString, values, onError);
				}
			} else {
				this._triggerFacetChange(facet, setSelected, trackingString, onError);
			}
		});
	},
	_triggerFacetRangeChange(facet, setSelected, trackingString, values, onError) {
		this.collection.trigger(
			'facets:items:rangeset',
			{
				facetId: facet.facetId,
				groupName: facet.groupName,
				facetValue: facet.value,
				selected: setSelected,
				selectedMin: values.min,
				selectedMax: values.max,
				isAdditive: true,
				trackingString: trackingString
			},
			onError
		);
	},
	_triggerFacetChange(facet, setSelected, trackingString, onError) {
		this.collection.trigger(
			'facets:items:set',
			{
				facetId: facet.facetId,
				groupName: facet.groupName,
				facetValue: facet.value,
				selected: setSelected,
				trackingString: trackingString
			},
			onError
		);
	},
	facetGroupExpandStatusModel: new FacetGroupsExpandStatuses(),
	_setFacetGroupsExpandStatuses: function(facetInformation, isActive) {
		// get names, dedupe, then pop into the format we want.
		const facetGroups = facetInformation
			.map((currentFacet) => {
				return currentFacet.groupName;
			})
			.sort()
			.filter((currentFacetName, index, array) => {
				return !index || currentFacetName !== array[index - 1];
			});

		facetGroups.forEach((currentFacetName) => {
			this.facetGroupExpandStatusModel.addGroup({
				pageType: window.dataLayer.categoryId ? 'category' : 'search',
				categoryId: window.dataLayer.categoryId,
				searchTerm: window.dataLayer.search ? window.dataLayer.search.name : '',
				groupName: currentFacetName,
				isExpanded: isActive
			});
		});

		this.facetGroupExpandStatusModel.save();
	}
});
